import { Record } from 'immutable'

export const UserGroupRecord = Record(
  {
    id: null,
    name: null,
    createdAt: null,
    updatedAt: null,
    members: null,
  },
  'userGroup'
)
